module.exports = __webpack_public_path__ + "static/media/ic_link.de6258b0.svg";